// Copyright (c) StrangeBee 2023

import { NotificationTriggerOutput, Notifiers, ObjectTypeV1 } from 'thehive-sdk';

export interface NotifiersMap {
    name: Notifiers;
    label?: string;
    isDelegate: boolean;
    triggerExclude?: NotificationTriggerOutput[];
    imgSrc: string;
    capabilities?: string[];
    disabled?: boolean;
}

export const notifierList: NotifiersMap[] = [
    {
        name: 'EmailerToUser',
        isDelegate: true,
        triggerExclude: ['AnyEvent', 'ObservableCreated', 'CaseObservableCreated', 'AlertObservableCreated'],
        imgSrc: 'static/icons/emailToUsers.svg',
        capabilities: ['emailerToUser'],
    },
    {
        name: 'EmailerToAddr',
        isDelegate: false,
        triggerExclude: [
            'ActionFinished',
            'AlertAssigned',
            'JobFinished',
            'LogInMyTask',
            'TaskAssigned',
            'ObservableCreated',
            'CaseObservableCreated',
            'AlertObservableCreated',
        ],
        imgSrc: 'static/icons/emailToAddr.svg',
        capabilities: ['emailerToAddr'],
    },
    {
        name: 'HttpRequest',
        isDelegate: false,
        triggerExclude: ['AlertAssigned', 'LogInMyTask', 'TaskAssigned'],
        imgSrc: 'static/icons/http.svg',
        capabilities: ['http'],
    },
    {
        name: 'Mattermost',
        isDelegate: false,
        triggerExclude: ['AlertAssigned', 'LogInMyTask', 'TaskAssigned'],
        imgSrc: 'static/icons/mattermost.svg',
        capabilities: ['mattermost'],
    },
    {
        name: 'Slack',
        isDelegate: false,
        triggerExclude: ['AlertAssigned', 'LogInMyTask', 'TaskAssigned'],
        imgSrc: 'static/icons/slack.svg',
        capabilities: ['slack'],
    },
    {
        name: 'Teams',
        isDelegate: false,
        triggerExclude: ['AlertAssigned', 'LogInMyTask', 'TaskAssigned'],
        imgSrc: 'static/icons/teams.svg',
        //  TEMP
        capabilities: ['teams'],
    },
    {
        name: 'Webhook',
        isDelegate: false,
        triggerExclude: ['AlertAssigned', 'LogInMyTask', 'TaskAssigned'],
        imgSrc: 'static/icons/webhooks.svg',
        capabilities: ['webhook'],
    },
    {
        name: 'Kafka',
        isDelegate: false,
        triggerExclude: ['AlertAssigned', 'LogInMyTask', 'TaskAssigned'],
        imgSrc: 'static/icons/kafka.svg',
        capabilities: ['kafka'],
    },
    {
        name: 'Redis',
        label: 'Redis (beta)',
        isDelegate: false,
        triggerExclude: ['AlertAssigned', 'LogInMyTask', 'TaskAssigned'],
        imgSrc: 'static/icons/redis.svg',
        //  TEMP
        capabilities: ['redis'],
    },
    {
        name: 'RunAnalyzer',
        isDelegate: false,
        triggerExclude: [
            'ActionFinished',
            'AlertAssigned',
            'AlertCreated',
            'AlertClosed',
            'AnyEvent',
            'CaseCreated',
            'CaseShared',
            'JobFinished',
            'LogInMyTask',
            'TaskAssigned',
            'AlertImported',
            'CaseClosed',
            'TaskClosed',
            'TaskMandatory',
        ],
        imgSrc: 'static/icons/cortex.svg',
        capabilities: ['cortex'],
    },
    {
        name: 'RunResponder',
        isDelegate: false,
        triggerExclude: ['AlertAssigned', 'AnyEvent', 'JobFinished', 'LogInMyTask', 'TaskAssigned'],
        imgSrc: 'static/icons/cortex-2.svg',
        capabilities: ['cortex'],
    },
];

export const triggers: Partial<Record<ObjectTypeV1 | 'default', NotificationTriggerOutput[]>> = {
    default: ['AnyEvent', 'FilteredEvent'],
    [ObjectTypeV1.ACTION]: ['ActionFinished'],
    [ObjectTypeV1.CASE]: ['CaseClosed', 'CaseCreated', 'CaseShared'],
    [ObjectTypeV1.ALERT]: ['AlertAssigned', 'AlertCreated', 'AlertImported', 'AlertClosed'],
    [ObjectTypeV1.JOB]: ['JobFinished'],
    [ObjectTypeV1.OBSERVABLE]: ['ObservableCreated', 'CaseObservableCreated', 'AlertObservableCreated'],
    [ObjectTypeV1.TASK]: ['TaskAssigned', 'TaskClosed', 'LogInMyTask', 'TaskMandatory'],
};
